/* VaultBag — comportamento da pagina de produto.
   Tres coisas: o carrossel de 1 item (avaliacoes curtas), o carrossel de videos de
   cliente (com o modal) e a barra fixa de compra. O modal das companhias aereas vem
   no fim, como estava na referencia. */

(function () {
  'use strict';

  /* ---------- carrossel de um item por vez (avaliacoes curtas) ---------- */
  function carrossel(raiz) {
    var trilho = raiz.querySelector('.splide__track');
    var lista = raiz.querySelector('.splide__list');
    if (!trilho || !lista || raiz.dataset.pronto) return;
    raiz.dataset.pronto = '1';
    var slides = Array.prototype.slice.call(lista.children);
    if (slides.length < 2) return;
    raiz.classList.add('is-overflow');   // e o que liga os pontinhos na folha da referencia

    var pag = raiz.querySelector('.splide__pagination');
    var setas = raiz.querySelector('.splide__arrows');
    /* Os data-* da secao ficam no pai do .splide e dizem a cor dos pontinhos e das
       setas ("inverse" = claro sobre fundo escuro). Sem essas classes o pontinho
       nasce da cor do texto e desaparece no cartao escuro. */
    var dono = raiz.parentElement;
    var corPontos = dono ? dono.getAttribute('data-dots-color') : null;
    var corSetas = dono ? dono.getAttribute('data-arrows-color') : null;
    var atual = 0;

    /* A referencia monta as setas pelo runtime do Splide. Onde a secao reserva o
       lugar delas (um .splide__arrows vazio no HTML), a replica monta as mesmas
       duas, com o mesmo desenho. Onde a secao nao reserva, nao aparece seta. */
    if (setas && !setas.children.length) {
      var seta = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false">' +
        '<path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg>';
      var cs = corSetas === 'inverse' ? ' color-inverse' : '';
      setas.innerHTML =
        '<button class="splide__arrow' + cs + ' splide__arrow--prev" type="button" aria-label="Previous slide">' + seta + '</button>' +
        '<button class="splide__arrow' + cs + ' splide__arrow--next" type="button" aria-label="Next slide">' + seta + '</button>';
    }
    if (pag) {
      var botoes = Array.prototype.slice.call(pag.querySelectorAll('.splide__pagination__page'));
      if (!botoes.length) {
        slides.forEach(function (_, i) {
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'splide__pagination__page' +   // a classe fica no botao, como na referencia
            (corPontos === 'inverse' ? ' color-inverse dots-custom-color' : '');
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          li.appendChild(b);
          pag.appendChild(li);
          botoes.push(b);
        });
      }
      // a referencia entrega os pontinhos prontos no HTML: sem isto eles ficam so de enfeite
      botoes.forEach(function (b, i) { b.addEventListener('click', function () { ir(i); }); });
    }

    /* A referencia congela --active-slide-height no HTML e a folha prende a altura do
       trilho nela. Com texto proprio o cartao passa disso e fica cortado, entao a
       altura sai do slide de verdade, como faz o adaptive height do Splide. */
    function altura() {
      var s = slides[atual];
      if (!s) return;
      var h = Math.ceil(s.getBoundingClientRect().height);
      if (h > 0) raiz.style.setProperty('--active-slide-height', h + 'px');
    }

    function marcar() {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === atual); });
      altura();
      if (pag) Array.prototype.forEach.call(pag.children, function (li, i) {
        li.classList.toggle('is-active', i === atual);
        var b = li.firstChild;
        if (b) {
          b.classList.toggle('is-active', i === atual);
          b.setAttribute('aria-current', String(i === atual));
        }
      });
      if (setas) {
        var p = setas.querySelector('.splide__arrow--prev');
        var n = setas.querySelector('.splide__arrow--next');
        if (p) p.disabled = atual === 0;
        if (n) n.disabled = atual === slides.length - 1;
      }
    }

    // o ultimo slide so alinha se houver folga de rolagem depois dele
    function folga() {
      var alvo = slides[slides.length - 1].offsetLeft - slides[0].offsetLeft;
      var maximo = trilho.scrollWidth - trilho.clientWidth;
      var falta = Math.ceil(alvo - maximo);
      var e = lista.querySelector('.vb-espacador');
      if (falta > 0) {
        if (!e) {
          e = document.createElement('li');
          e.className = 'vb-espacador';
          e.setAttribute('aria-hidden', 'true');
          e.style.cssText = 'list-style:none;flex:0 0 auto;height:1px';
          lista.appendChild(e);
        }
        e.style.width = falta + 'px';
      } else if (e) {
        e.remove();
      }
    }

    function ir(i) {
      atual = Math.max(0, Math.min(slides.length - 1, i));
      trilho.scrollTo({ left: slides[atual].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      marcar();
    }

    if (setas) {
      setas.addEventListener('click', function (ev) {
        var b = ev.target.closest('button');
        if (!b) return;
        ir(atual + (b.classList.contains('splide__arrow--prev') ? -1 : 1));
      });
    }
    var esperando;
    trilho.addEventListener('scroll', function () {
      clearTimeout(esperando);
      esperando = setTimeout(function () {
        var base = slides[0].offsetLeft;
        var perto = 0, dist = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs((s.offsetLeft - base) - trilho.scrollLeft);
          if (d < dist) { dist = d; perto = i; }
        });
        atual = perto;
        marcar();
      }, 90);
    });
    folga();
    window.addEventListener('resize', folga);
    window.addEventListener('resize', altura);
    window.addEventListener('load', altura);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(altura);
    raiz.querySelectorAll('img').forEach(function (im) {
      if (!im.complete) im.addEventListener('load', altura);
    });
    marcar();
  }

  /* ---------- carrossel do Replo (sem o runtime dele) ----------
     A referencia mostra um cartao por vez no celular; as setas sao do runtime do
     Replo, que nao veio junto. Aqui elas viram rolagem do proprio trilho. */
  function carrosselReplo(trilho) {
    if (trilho.dataset.pronto) return;
    trilho.dataset.pronto = '1';
    var palco = trilho.closest("[id*='replo-carousel']:not([id*='::track'])") || trilho.parentElement;
    var slides = Array.prototype.slice.call(trilho.querySelectorAll("[id*='::slide:']"));
    if (slides.length < 2) return;
    var botoes = Array.prototype.slice.call(palco.querySelectorAll('button'));
    if (botoes.length < 2) return;
    // a captura veio com as setas desabilitadas (o runtime do Replo liga/desliga sozinho)
    botoes.forEach(function (b) { b.disabled = false; b.removeAttribute('disabled'); b.style.pointerEvents = 'auto'; });
    function passo(dir) {
      var largura = slides[0].getBoundingClientRect().width;
      trilho.scrollBy({ left: dir * largura, behavior: 'smooth' });
    }
    botoes[0].addEventListener('click', function (ev) { ev.preventDefault(); passo(-1); });
    botoes[botoes.length - 1].addEventListener('click', function (ev) { ev.preventDefault(); passo(1); });
  }

  /* ---------- videos das secoes do Replo ----------
     Sem o runtime do Replo o <video> fica parado no poster e o simbolo de play nao
     e um botao. Aqui ele toca mudo em laco, como a referencia, e o clique liga o som
     (clicar de novo pausa). Sair do modal ja devolve o silencio ao resto da pagina. */
  function videosDoReplo() {
    document.querySelectorAll('[data-section-id] video').forEach(function (v) {
      if (v.dataset.prontoReplo) return;
      v.dataset.prontoReplo = '1';
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('playsinline', '');
      var tocar = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if (v.readyState >= 2) tocar(); else v.addEventListener('loadeddata', tocar, { once: true });
      var palco = v.closest('[id*="::slide:"]') || v.parentElement || v;
      palco.style.cursor = 'pointer';
      palco.addEventListener('click', function () {
        if (v.paused || v.muted) {
          document.querySelectorAll('video').forEach(function (o) { if (o !== v) o.muted = true; });
          v.muted = false; tocar();
        } else {
          v.pause();
        }
      });
    });
  }

  /* ---------- carrossel dos videos de cliente ---------- */
  function videos(raiz) {
    if (raiz.dataset.pronto) return;
    raiz.dataset.pronto = '1';
    var fita = raiz.querySelector('.swiper-wrapper');
    if (!fita) return;
    var slides = Array.prototype.slice.call(fita.children);
    var prev = raiz.querySelector('[class*="video-btn-prev"]');
    var next = raiz.querySelector('[class*="video-btn-next"]');

    function passo(dir) {
      var largura = slides.length ? slides[0].getBoundingClientRect().width + 12 : 240;
      fita.scrollBy({ left: dir * largura, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { passo(-1); });
    if (next) next.addEventListener('click', function () { passo(1); });

    // a referencia so mostra as setas quando ha o que rolar
    function ajustarSetas() {
      var sobra = fita.scrollWidth - fita.clientWidth;
      [prev, next].forEach(function (b) { if (b) b.style.display = sobra > 2 ? '' : 'none'; });
    }
    ajustarSetas();
    window.addEventListener('resize', ajustarSetas);

    // os videos tocam mudos em laco, como na referencia
    raiz.querySelectorAll('video').forEach(function (v) {
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('playsinline', '');
      var tocar = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if (v.readyState >= 2) tocar(); else v.addEventListener('loadeddata', tocar, { once: true });
    });

    /* ---------- a janela do video ----------
       A referencia monta a janela com UM SLIDE POR VIDEO da fita: as setas trocam
       de slide, o som tem botao proprio e a janela abre marcando a classe `active`.
       E o `active` que a folha usa para trazer a janela para a frente — a regra
       base joga a janela para z-index -1 no celular. Marcando outra classe, a
       janela abria atras da pagina com a rolagem travada. */
    var modal = document.querySelector('[class*="video-modal-"]');
    if (!modal || modal.dataset.pronto) return;
    var trilho = modal.querySelector('.swiper-wrapper');
    var molde = modal.querySelector('[class*="video-modal-slide-"]');
    if (!trilho || !molde) return;
    modal.dataset.pronto = '1';
    /* O snippet da janela vem com os videos do carro-chefe dentro. Quem manda e a
       fita desta pagina: um slide por video dela, com o video real deste produto. */
    var moldeLimpo = molde.cloneNode(true);
    trilho.innerHTML = '';
    var modais = slides.map(function (s) {
      var novo = moldeLimpo.cloneNode(true);
      var antigo = novo.querySelector('video');
      var origem = s.querySelector('video');
      if (origem && antigo) {
        var copia = origem.cloneNode(true);
        copia.removeAttribute('autoplay');
        copia.controls = false; copia.loop = true; copia.playsInline = true; copia.muted = true;
        antigo.parentNode.replaceChild(copia, antigo);
      }
      trilho.appendChild(novo);
      return novo;
    });
    var noModal = 0;
    var anterior = modal.querySelector('[class*="video-modal-prev-"]');
    var proximo = modal.querySelector('[class*="video-modal-next-"]');
    // com um video so nao ha para onde ir: a referencia tranca as setas
    if (modais.length < 2) [anterior, proximo].forEach(function (b) { if (b) b.style.display = 'none'; });

    function mostrar(i) {
      noModal = Math.max(0, Math.min(modais.length - 1, i));
      // um slide por vez, com o respiro de 20px do carrossel da referencia
      trilho.style.transform = 'translate3d(calc(' + (-noModal) + ' * (100% + 20px)), 0, 0)';
      modais.forEach(function (s, k) {
        var v = s.querySelector('video');
        var acao = s.querySelector('[class*="video-modal-action-"]');
        if (!v) return;
        if (k === noModal) {
          v.muted = false;
          if (acao) acao.classList.add('active');
          var p = v.play();
          // navegador que barra audio sem gesto: volta para mudo em vez de nao tocar
          if (p && p.catch) p.catch(function () { v.muted = true; if (acao) acao.classList.remove('active'); v.play(); });
        } else {
          v.pause(); v.muted = true;
          if (acao) acao.classList.remove('active');
        }
      });
      if (anterior) anterior.classList.toggle('swiper-button-disabled', noModal === 0);
      if (proximo) proximo.classList.toggle('swiper-button-disabled', noModal === modais.length - 1);
    }
    function abrir(i) {
      document.body.style.overflow = 'hidden';
      modal.classList.add('active');
      mostrar(i);
    }
    function fechar() {
      modal.classList.remove('active');
      document.body.style.overflow = '';
      modais.forEach(function (s) { var v = s.querySelector('video'); if (v) { v.pause(); v.muted = true; } });
    }
    slides.forEach(function (s, i) {
      s.addEventListener('click', function () { abrir(i); });
    });
    if (anterior) anterior.addEventListener('click', function (ev) { ev.stopPropagation(); mostrar(noModal - 1); });
    if (proximo) proximo.addEventListener('click', function (ev) { ev.stopPropagation(); mostrar(noModal + 1); });
    modal.addEventListener('click', function (ev) {
      var acao = ev.target.closest && ev.target.closest('[class*="video-modal-action-"]');
      if (acao) {
        // o botao de som da referencia: alterna o audio do video que esta na tela
        ev.stopPropagation();
        var slide = acao.closest('[class*="video-modal-slide-"]');
        var v = slide && slide.querySelector('video');
        acao.classList.toggle('active');
        if (v) v.muted = !acao.classList.contains('active');
        return;
      }
      if (ev.target === modal || (ev.target.closest && ev.target.closest('[class*="video-modal-close-"]'))) fechar();
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && modal.classList.contains('active')) fechar();
    });
  }

  /* ---------- barra fixa de compra ---------- */
  function barraFixa() {
    var barra = document.querySelector('[data-vb-sticky]');
    if (!barra || barra.dataset.pronto) return;
    barra.dataset.pronto = '1';
    var alvo = document.querySelector('.product-form__submit') || document.querySelector('[name="add"]');
    if (!alvo) return;

    function medir() {
      var caixa = alvo.getBoundingClientRect();
      var passou = caixa.bottom < 0;
      barra.classList.toggle('sticky-atc--visivel', passou);
    }
    window.addEventListener('scroll', medir, { passive: true });
    window.addEventListener('resize', medir);
    medir();

    barra.querySelectorAll('.sticky-atc__scroll-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        alvo.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    var selecao = barra.querySelector('.sticky-atc__variant-select');
    if (selecao) {
      selecao.addEventListener('change', function () {
        var radio = document.querySelector('.color-swatch input[value="' + selecao.value.replace(/"/g, '\\"') + '"]');
        if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }
  }


  /* ---- os CTAs das secoes levam ao botao de compra ---- */
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest && ev.target.closest('a[href="#shopify-section-main"]');
    if (!a) return;
    var alvo = document.querySelector('.product-form__submit') || document.querySelector('[name="add"]');
    if (!alvo) return;
    ev.preventDefault();
    alvo.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* ---- "GET YOURS TODAY" e os outros CTAs de compra das secoes ----
     A referencia liga todo [id^="SectionAtcBtn-"] ao handleSubmit do product-form
     principal num script solto da PDP. Esse script nao veio no porte e os botoes
     ficaram sem ninguem escutando o clique. Aqui o clique vai no botao de compra
     de verdade, que e quem fala com o widget de ofertas e abre a gaveta. */
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest && ev.target.closest('[id^="SectionAtcBtn-"]');
    if (!b) return;
    var caixa = document.querySelector('#shopify-section-main') ||
                document.querySelector('[id^="shopify-section-"][id$="__main"]');
    function achar(raiz) {
      if (!raiz) return null;
      return raiz.querySelector('.product-form__submit:not([disabled])') ||
             raiz.querySelector('button[name="add"]:not([disabled])');
    }
    var alvo = achar(caixa) || achar(document);
    if (!alvo) return;
    ev.preventDefault();
    alvo.click();
  });

  /* ---- o modal vai para o corpo: ancestral com transform quebra o position fixed ---- */
  function soltarModal() {
    ['#vbOverlay', '[data-vb-sticky]', '[class*="video-modal-"]'].forEach(function (sel) {
      var m = document.querySelector(sel);
      if (m && m.parentNode !== document.body) document.body.appendChild(m);
    });
  }

  function iniciar() {
    soltarModal();
    document.querySelectorAll('.review-items-container .splide').forEach(carrossel);
    /* Depoimentos que a referencia mostra um por vez no celular (data-slides-mobile="1").
       So no celular: no desktop a referencia destroi o carrossel e vira grade de tres
       (data-destroy-desktop), e ligar os pontinhos la criaria enfeite que ela nao tem. */
    if (window.matchMedia('(max-width: 749px)').matches) {
      document.querySelectorAll('[data-slides-mobile="1"] .splide').forEach(carrossel);
    }
    document.querySelectorAll("[id*='replo-carousel'][id*='::track']").forEach(carrosselReplo);
    videosDoReplo();
    document.querySelectorAll('[class*="video-slider-"]').forEach(videos);
    barraFixa();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
})();

/* ---------- modal das companhias aereas (comportamento da referencia) ---------- */

document.addEventListener('DOMContentLoaded', function(){
  const vbAirlines=[
    {name:"Ryanair",l:40,w:30,h:20,free:true},
    {name:"easyJet",l:45,w:36,h:20,free:true},
    {name:"Wizz Air",l:40,w:30,h:20,free:true},
    {name:"Jet2",l:40,w:30,h:20,free:true},
    {name:"TUI",l:55,w:40,h:20,free:false},
    {name:"British Airways",l:40,w:30,h:15,free:false},
    {name:"Virgin Atlantic",l:40,w:30,h:15,free:false},
    {name:"Aer Lingus",l:33,w:25,h:20,free:false},
    {name:"Air Arabia",l:55,w:40,h:20,free:false},
    {name:"Air Asia",l:56,w:36,h:23,free:false},
    {name:"Air Canada",l:43,w:33,h:16,free:false},
    {name:"Air France",l:40,w:30,h:15,free:false},
    {name:"Air Malta",l:55,w:40,h:23,free:false},
    {name:"Air New Zealand",l:55,w:42,h:25,free:false},
    {name:"Air Serbia",l:55,w:40,h:23,free:false},
    {name:"Alaska Airlines",l:55,w:35,h:22,free:false},
    {name:"Alitalia",l:55,w:35,h:25,free:false},
    {name:"Allegiant Air",l:56,w:36,h:22,free:false},
    {name:"ANA",l:55,w:40,h:25,free:false},
    {name:"American Airlines",l:45,w:35,h:20,free:false},
    {name:"Asiana Airlines",l:55,w:40,h:20,free:false},
    {name:"Austrian Airlines",l:55,w:40,h:23,free:false},
    {name:"Brussels Airlines",l:55,w:40,h:23,free:false},
    {name:"Cathay Pacific",l:56,w:36,h:23,free:false},
    {name:"China Eastern",l:55,w:40,h:20,free:false},
    {name:"China Southern",l:55,w:40,h:20,free:false},
    {name:"Corendon",l:55,w:40,h:20,free:false},
    {name:"Croatia Airlines",l:55,w:40,h:23,free:false},
    {name:"Czech Airlines",l:55,w:45,h:25,free:false},
    {name:"Delta Airlines",l:40,w:30,h:15,free:false},
    {name:"EL AL",l:56,w:45,h:25,free:false},
    {name:"Emirates",l:55,w:38,h:20,free:false},
    {name:"Etihad",l:50,w:40,h:25,free:false},
    {name:"Eurowings",l:40,w:30,h:10,free:false},
    {name:"Finnair",l:40,w:30,h:15,free:false},
    {name:"Flydubai",l:55,w:38,h:20,free:false},
    {name:"Frontier Airlines",l:56,w:35,h:22,free:false},
    {name:"Garuda Indonesia",l:56,w:36,h:23,free:false},
    {name:"Hainan Airlines",l:55,w:40,h:20,free:false},
    {name:"Iberia",l:40,w:30,h:15,free:false},
    {name:"IndiGo",l:55,w:35,h:25,free:false},
    {name:"Jazeera Airways",l:55,w:38,h:20,free:false},
    {name:"Jet Airways",l:55,w:35,h:25,free:false},
    {name:"JetBlue",l:43,w:33,h:20,free:false},
    {name:"Kenya Airways",l:56,w:40,h:23,free:false},
    {name:"KLM",l:40,w:30,h:15,free:false},
    {name:"Korean Air",l:55,w:40,h:20,free:false},
    {name:"LATAM Airlines",l:56,w:35,h:22,free:false},
    {name:"LOT Polish Airlines",l:55,w:40,h:23,free:false},
    {name:"Lufthansa",l:40,w:30,h:10,free:false},
    {name:"Malindo Air",l:56,w:36,h:23,free:false},
    {name:"Norwegian",l:40,w:23,h:33,free:false},
    {name:"Oman Air",l:55,w:40,h:22,free:false},
    {name:"Pegasus Airlines",l:55,w:40,h:20,free:false},
    {name:"Philippine Airlines",l:56,w:36,h:23,free:false},
    {name:"Qantas",l:56,w:36,h:23,free:false},
    {name:"Qatar Airways",l:50,w:37,h:25,free:false},
    {name:"Royal Air Maroc",l:55,w:35,h:25,free:false},
    {name:"Royal Jordanian",l:55,w:40,h:20,free:false},
    {name:"SAS",l:55,w:40,h:23,free:false},
    {name:"Singapore Airlines",l:55,w:38,h:20,free:false},
    {name:"SmartWings",l:55,w:40,h:20,free:false},
    {name:"Southwest Airlines",l:47,w:34,h:18,free:false},
    {name:"Spirit Airlines",l:56,w:35,h:22,free:false},
    {name:"Sun Express",l:55,w:40,h:20,free:false},
    {name:"Swiss",l:55,w:40,h:23,free:false},
    {name:"TAP Air Portugal",l:55,w:40,h:20,free:false},
    {name:"Thai Airways",l:56,w:45,h:25,free:false},
    {name:"Transavia",l:55,w:35,h:25,free:false},
    {name:"Turkish Airlines",l:55,w:40,h:23,free:false},
    {name:"United Airlines",l:43,w:25,h:22,free:false},
    {name:"Volotea",l:55,w:40,h:20,free:false},
    {name:"Vueling",l:40,w:30,h:20,free:false},
    {name:"WestJet",l:51,w:40,h:23,free:false},
  ];

  const MY={l:40,w:30,h:20};
  const trigger=document.getElementById('vbTrigger');
  const overlay=document.getElementById('vbOverlay');
  const closeBtn=document.getElementById('vbClose');
  const search=document.getElementById('vbSearch');
  const list=document.getElementById('vbList');
  const verdict=document.getElementById('vbVerdict');

  if(!trigger||!overlay||!closeBtn||!search||!list||!verdict) return;

  function fits(a){return MY.l<=a.l && MY.w<=a.w && MY.h<=a.h;}

  function showVerdict(a){
    verdict.classList.add('show');
    document.getElementById('vbVerdictAirline').textContent=a.name.toUpperCase();
    const txt=document.getElementById('vbVerdictText');
    const sub=document.getElementById('vbVerdictSub');
    const bagFits=fits(a);
    if(bagFits){
      txt.textContent='Your VAULTBAG® flies free';
      if(a.free){sub.textContent='Flies free underseat — no weight limit';}
      else{sub.textContent='Flies free — fits in the overhead locker';}
      sub.className='vb-verdict-status free';
    } else {
      txt.textContent='Check airline directly';
      sub.textContent='Their underseat limit is smaller than 40×30×20cm';
      sub.className='vb-verdict-status';
      sub.style.color='#888';
    }
    const dims=[
      {label:'Length',mine:MY.l,theirs:a.l},
      {label:'Width',mine:MY.w,theirs:a.w},
      {label:'Height',mine:MY.h,theirs:a.h}
    ];
    document.getElementById('vbDims').innerHTML=dims.map(d=>{
      const ok=d.mine<=d.theirs;
      return `<div class="vb-dims-row">
        <span class="vb-dims-label">${d.label}</span>
        <div class="vb-dims-values">
          <span class="vb-dims-yours">${d.mine}cm</span>
          <span class="vb-dims-sep">of</span>
          <span class="vb-dims-limit">${d.theirs}cm limit</span>
          <div class="vb-dims-tick" style="${ok?'':'background:#ff4d4d'}"><svg width="8" height="8" viewBox="0 0 10 10" fill="none"><polyline points="1.5 5 4 7.5 8.5 2.5" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
        </div>
      </div>`;
    }).join('');
  }

  function renderList(filter){
    const q=(filter||'').toLowerCase();
    const filtered=vbAirlines.filter(a=>a.name.toLowerCase().includes(q));
    if(!filtered.length){list.innerHTML='<div class="vb-empty">No airlines found</div>';return;}
    list.innerHTML=filtered.map(a=>`
      <div class="vb-row" data-name="${a.name}">
        <div class="vb-row-left">
          <div class="vb-tick"><svg width="8" height="8" viewBox="0 0 10 10" fill="none"><polyline points="1.5 5 4 7.5 8.5 2.5" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
          <span class="vb-row-name">${a.name}</span>
        </div>
        <div class="vb-row-right">
          <div class="vb-row-limit">${a.l}×${a.w}×${a.h}cm</div>
          <div class="vb-row-status">${a.free ? 'Flies free underseat — no weight limit' : 'Flies free — fits overhead'}</div>
        </div>
      </div>`).join('');
    list.querySelectorAll('.vb-row').forEach(row=>{
      row.addEventListener('click',()=>{
        list.querySelectorAll('.vb-row').forEach(r=>r.classList.remove('active'));
        row.classList.add('active');
        const airline=vbAirlines.find(a=>a.name===row.dataset.name);
        if(airline)showVerdict(airline);
      });
    });
  }

  trigger.addEventListener('click',()=>{overlay.classList.add('open');search.value='';verdict.classList.remove('show');renderList('');setTimeout(()=>search.focus(),300);});
  closeBtn.addEventListener('click',()=>overlay.classList.remove('open'));
  overlay.addEventListener('click',e=>{if(e.target===overlay)overlay.classList.remove('open');});
  search.addEventListener('input',()=>{verdict.classList.remove('show');renderList(search.value);});
  renderList('');
});


/* ---- galeria agrupada por cor ----------------------------------------------
   O tema recebe as 86 midias do produto e esconde as das outras cores no
   servidor. Ao trocar de cor no navegador, o tema so troca preco e botao, entao
   e aqui que a galeria e a fita de miniaturas passam para o novo grupo.        */
(function () {
  var galeria = document.querySelector('media-gallery[id^="MediaGallery-"]');
  if (!galeria || !galeria.querySelector('[data-alt]')) return;

  function aplicar(cor) {
    if (!cor) return;
    var primeiro = null;
    var lupa = document.querySelector('product-modal');
    [galeria, lupa].forEach(function (raiz) {
      if (!raiz) return;
      raiz.querySelectorAll('[data-alt]').forEach(function (el) {
        var mesma = el.getAttribute('data-alt') === cor;
        el.classList.toggle('hidden', !mesma);
        if (raiz === galeria && mesma && !primeiro && el.hasAttribute('data-media-id')) primeiro = el;
      });
    });
    galeria.querySelectorAll('slider-component').forEach(function (s) {
      if (typeof s.resetPages === 'function') s.resetPages();
    });
    if (primeiro && typeof galeria.setActiveMedia === 'function') {
      galeria.setActiveMedia(primeiro.getAttribute('data-media-id'), false);
    }
    if (typeof window.vbLigarVideoDaGaleria === 'function') window.vbLigarVideoDaGaleria();
  }

  document.addEventListener('change', function (e) {
    var campo = e.target;
    if (!campo || campo.type !== 'radio' || !campo.closest('variant-selects')) return;
    aplicar(campo.value);
  });
})();

/* ---- o video da galeria toca sozinho, mudo e em laco, como na referencia ----
   O Dawn entrega o video embrulhado: cartaz com botao de play, e o video de
   verdade so nasce no clique. Aqui ele nasce junto com a pagina.              */
(function () {
  var galeria = document.querySelector('media-gallery[id^="MediaGallery-"]');
  if (!galeria) return;

  function tocar(dm) {
    var v = dm.querySelector('video');
    if (!v) return;
    v.muted = true; v.loop = true; v.playsInline = true; v.controls = false;
    v.removeAttribute('controls');
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function ligar() {
    galeria.querySelectorAll('li.product__media-item:not(.hidden) deferred-media').forEach(function (dm) {
      if (!dm.getAttribute('loaded')) {
        var tpl = dm.querySelector('template');
        var fonte = tpl && tpl.content.querySelector('video');
        if (!fonte) return;
        dm.appendChild(fonte.cloneNode(true));
        dm.setAttribute('loaded', true);
      }
      tocar(dm);
    });
  }

  window.vbLigarVideoDaGaleria = ligar;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar);
  else ligar();

  /* clicar numa miniatura faz o tema mandar pausar tudo, e o video nao volta
     sozinho porque ja estava carregado — aqui ele volta */
  galeria.addEventListener('click', function () { setTimeout(ligar, 80); });
  var visor = galeria.querySelector('slider-component[id^="GalleryViewer"]');
  if (visor) visor.addEventListener('slideChanged', function () { setTimeout(ligar, 80); });
})();

/* ---- setas sobre a foto grande, como as da referencia ----------------------
   O Dawn poe as setas embaixo da galeria e as esconde no celular. A referencia
   poe duas bolinhas de 33px sobre a foto, a 11px de cada borda.               */
(function () {
  var galeria = document.querySelector('media-gallery[id^="MediaGallery-"]');
  if (!galeria) return;
  var visor = galeria.querySelector('slider-component[id^="GalleryViewer"]');
  if (!visor || visor.querySelector('.vb-seta')) return;

  var CARET = '<svg viewBox="0 0 40 40" aria-hidden="true" focusable="false">' +
              '<path d="M24.5 11.5 16 20l8.5 8.5" fill="none" stroke="currentColor" ' +
              'stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function slides() {
    return [].slice.call(visor.querySelectorAll('li.product__media-item:not(.hidden)'));
  }
  function indiceAtivo(lista) {
    for (var i = 0; i < lista.length; i++) if (lista[i].classList.contains('is-active')) return i;
    return 0;
  }
  function ir(passo) {
    var lista = slides();
    var alvo = lista[indiceAtivo(lista) + passo];
    if (alvo && typeof galeria.setActiveMedia === 'function') {
      galeria.setActiveMedia(alvo.getAttribute('data-media-id'), false);
    }
    setTimeout(atualizar, 90);
  }
  function atualizar() {
    var lista = slides(), i = indiceAtivo(lista);
    anterior.disabled = i <= 0;
    proxima.disabled = i >= lista.length - 1;
  }

  function criar(classe, rotulo, passo) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'vb-seta ' + classe;
    b.setAttribute('aria-label', rotulo);
    b.setAttribute('aria-controls', visor.id);
    b.innerHTML = CARET;
    b.addEventListener('click', function () { ir(passo); });
    return b;
  }
  var anterior = criar('vb-seta--anterior', 'Previous slide', -1);
  var proxima = criar('vb-seta--proxima', 'Next slide', 1);
  visor.appendChild(anterior);
  visor.appendChild(proxima);

  galeria.addEventListener('click', function () { setTimeout(atualizar, 120); });
  visor.addEventListener('slideChanged', function () { setTimeout(atualizar, 60); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio' && e.target.closest('variant-selects')) setTimeout(atualizar, 200);
  });
  atualizar();
})();

/* ---- vigia dos videos: nenhum fica parado no cartaz ------------------------
   O Chrome pausa video mudo que sai da tela e nem sempre volta a tocar quando
   ele reaparece. Aqui, todo video de tocar-sozinho que estiver visivel e
   parado volta a rodar.                                                       */
(function () {
  var TENTATIVAS = new WeakMap();

  function candidato(v) {
    return v.autoplay && v.muted && !v.controls;
  }
  function visivel(v) {
    var r = v.getBoundingClientRect();
    if (r.width < 8 || r.height < 8) return false;
    return r.bottom > 0 && r.top < (window.innerHeight || 0) + 200;
  }
  function tocar(v) {
    var n = TENTATIVAS.get(v) || 0;
    if (n > 40) return;
    TENTATIVAS.set(v, n + 1);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function varrer() {
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      if (!candidato(v) || !v.paused) return;
      if (visivel(v)) tocar(v);
    });
  }

  if ('IntersectionObserver' in window) {
    var olho = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting && candidato(e.target) && e.target.paused) tocar(e.target);
      });
    }, { threshold: 0.1, rootMargin: '200px 0px' });
    var observados = new WeakSet();
    setInterval(function () {
      document.querySelectorAll('video[autoplay]').forEach(function (v) {
        if (observados.has(v)) return;
        observados.add(v); olho.observe(v);
        v.addEventListener('canplay', function () { if (candidato(v) && v.paused && visivel(v)) tocar(v); });
      });
    }, 2000);
  }
  document.addEventListener('scroll', function () { clearTimeout(window.__vbVigia); window.__vbVigia = setTimeout(varrer, 250); }, { passive: true });
  setInterval(varrer, 1500);
  varrer();
})();
